import { createSupabaseClient } from './createSupabaseClient'

/** Main app auth session (default Supabase storage key). */
export const supabase = createSupabaseClient()

/** Isolated admin subdomain session — does not share tokens with the main app. */
export const adminSupabase = createSupabaseClient('traderhub-admin-auth')
